import { render, staticRenderFns } from "./AdvancedTab.vue?vue&type=template&id=0f6a4dd7&"
import script from "./AdvancedTab.vue?vue&type=script&lang=js&"
export * from "./AdvancedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports